import { useQuery } from '@tanstack/react-query';

import { queries } from '@/queries';

import { customVerticalLinks } from './customVerticalLinks';
import type { DropdownColumn, DropdownLink } from './Desktop/NavDropdown';
import type { NavItem } from './navigation';
import { navigation as staticNavigation } from './navigation';

export const FOR_BUSINESS_LABEL = 'For Business';

export const useNavigation = (): NavItem[] => {
  const { data: industries } = useQuery(queries.industries.navigation);

  if (!industries?.length) return staticNavigation;

  return staticNavigation.map((item) => {
    if (item.label !== FOR_BUSINESS_LABEL) return item;

    const columns: DropdownColumn[] = item.columns.map((column) => ({
      ...column,
      links: [...column.links],
    }));

    industries.forEach((industry) => {
      const title = industry.navigationLabel || industry.name;
      const industryLinks: DropdownLink[] = [
        ...(industry.verticals ?? []).map((vertical) => ({
          label: vertical.navigationLabel || vertical.title,
          linkType: 'internal' as const,
          href: {
            pathname: '/industry/[industrySlug]/[verticalSlug]',
            query: { industrySlug: industry.slug, verticalSlug: vertical.slug },
          },
        })),
        ...(customVerticalLinks[industry.slug] ?? []),
      ];
      const industryLink: DropdownColumn['link'] = {
        linkType: 'internal',
        href: {
          pathname: '/industry/[industrySlug]',
          query: { industrySlug: industry.slug },
        },
      };

      const existingColumn = columns.find((column) => column.title === title);
      if (existingColumn) {
        existingColumn.links.push(...industryLinks);
        existingColumn.link ??= industryLink;
      } else {
        columns.push({
          title,
          description: industry.navigationDescription ?? undefined,
          link: industryLink,
          links: industryLinks,
        });
      }
    });

    return { ...item, columns };
  });
};
